import EDC from '../../../shared/globals';
import { AnswerMark } from '../../../shared/mark-animation';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';
import router from '@/router';

EDC.Games.SoundsMultichoice.Scenes.Main = function () {
  const gameId = router.currentRoute.params.id;
  BaseMinigamesMain.apply(this);

  this.gameConfig = store.getters['games/getGameById'](gameId).sets[0].config;
  this.gameData = EDC.Games.SoundsMultichoice.GameData;
  this.difficulty = 1;
  this.iteration = 0;
  this.caveman = null;
  this.answers = [];
  this.otherSprites = [];
};

EDC.Games.SoundsMultichoice.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
// eslint-disable-next-line max-len
EDC.Games.SoundsMultichoice.Scenes.Main.prototype.constructor = EDC.Games.SoundsMultichoice.Scenes.Main;

const SM = EDC.Games.SoundsMultichoice.Scenes.Main.prototype;

SM.create = function () {
  this.initialize();

  this.createTemplateUI();
  this.loadIteration();
  const speech = this.add.sprite(this.caveman.x - this.caveman.displayWidth, 665, 'speech').setOrigin(0, 0.5);
  this.otherSprites.push(speech);

  this.createBasicUI();
};

SM.loadIteration = function () {
  this.addCaveman();
  this.createAnswers();
  this.fadeBack();
};

SM.fadeBack = function () {
  this.answers.map((x) => {
    x.setAlpha(0);
    this.tweens.add({
      targets: x,
      alpha: 1,
      duration: 500,
      ease: 'Sine.easeInOut',
      yoyo: false,
    });
  });
  this.caveman.setAlpha(0);
  this.tweens.add({
    targets: this.caveman,
    alpha: 1,
    duration: 500,
    ease: 'Sine.easeInOut',
    yoyo: false,
  });
};

SM.createAnswers = function () {
  const { answersCount } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const correctAnswer = this.caveman.soundKey;
  let keys = [];
  keys.push(correctAnswer);
  for (let i = 0; i < answersCount - 1; i++) {
    const key = Math.floor(Math.random() * this.gameConfig.assets.sounds.length);
    if (key === correctAnswer || keys.indexOf(key) !== -1) {
      i--;
    } else {
      keys.push(key);
    }
  }
  keys = this.shuffle(keys);
  const font = {
    font: `${this.gameConfig.answerSize} ${this.gameConfig.font}`,
  };
  for (let i = 0; i < keys.length; i++) {
    const container = this.add.container(0, 335);
    const rock = this.add.sprite(0, 0, 'answer-frame').setScale(0.85);
    const text = this.add.text(
      0,
      -15,
      this.gameConfig.assets.sounds[keys[i]].text,
      font,
    ).setOrigin(0.5);
    this.generateTint(text);
    container.add(rock);
    container.add(text);
    container.setSize(rock.displayWidth, rock.displayHeight);
    if (keys[i] === correctAnswer) {
      container.isCorrect = true;
    } else {
      container.isCorrect = false;
    }
    this.startShakeAnimation(container);
    container.setInteractive();
    const markAnim = new AnswerMark(this, container).setScale(0.45);
    container.setData('markAnim', markAnim);
    this.cursorManager.setDefaultDraggableEvents(container);
    container.on('pointerup', this.checkAnswer.bind(this, container), this);
    this.answers.push(container);
  }
  this.adjustPosition(this.answers);
};

SM.generateTint = function (text) {
  // let tints = [];
  // for (let i = 0; i < 4; i++) {
  //   let tint = Math.random() * 0xffffff;
  //   tints.push(tint);
  // }
  // text.setTint(tints[0], tints[1], tints[2], tints[3]);
};

SM.checkAnswer = function (answer) {
  if (answer.isCorrect) {
    this.playCorrect();
    this.answers.map((x) => {
      x.disableInteractive();
      x.shakeAnim.stop();
      x.angle = 0;
    });
    this.caveman.scaleAnim.stop();
    this.caveman.setScale(1);
    answer.getData('markAnim').showMark(true, () => {});
    this.time.delayedCall(2000, this.shrinkAnimation, [], this);
  } else {
    answer.first.setTint(0xff0000);
    answer.shakeAnim.stop();
    answer.angle = 0;
    answer.disableInteractive();
    this.playWrong();
    answer.getData('markAnim').showMark(false, () => {});
  }
};

SM.shrinkAnimation = function () {
  this.answers.map((x) => {
    this.tweens.add({
      targets: x,
      scaleX: '+=0.2',
      scaleY: '+=0.2',
      duration: 300,
      ease: 'Sine.easeInOut',
      yoyo: false,
    });
    this.tweens.add({
      targets: x,
      scaleX: 0,
      scaleY: 0,
      duration: 500,
      delay: 300,
      ease: 'Sine.easeInOut',
      yoyo: false,
    });
  });
  this.tweens.add({
    targets: this.caveman,
    scaleX: '+=0.1',
    scaleY: '+=0.1',
    duration: 300,
    ease: 'Sine.easeInOut',
    yoyo: false,
  });
  this.tweens.add({
    targets: this.caveman,
    scaleX: 0,
    scaleY: 0,
    duration: 500,
    delay: 300,
    ease: 'Sine.easeInOut',
    yoyo: false,
    onComplete: this.nextIteration.bind(this),
  });
};

SM.nextIteration = function () {
  this.answers.map((x) => {
    x.destroy();
  });
  this.answers = [];
  this.caveman.destroy();
  this.caveman = null;
  this.iteration++;
  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    this.otherSprites.map((x) => {
      x.destroy();
    });
    this.showSummary();
  } else {
    this.loadIteration();
  }
};

SM.adjustPosition = function (array) {
  const width = array.length * array[0].displayWidth;
  const startingX = (this.game.config.width - width) / 2;
  for (let i = 0; i < array.length; i++) {
    array[i].x = startingX + (array[0].displayWidth + 80) * i;
    array[i].init_X = array[i].x;
  }
};

SM.shuffle = function (array) {
  let j;
  let x;
  let i;
  for (i = array.length - 1; i > 0; i--) {
    j = Math.floor(Math.random() * (i + 1));
    x = array[i];
    array[i] = array[j];
    array[j] = x;
  }
  return array;
};

SM.addCaveman = function () {
  const caveman = this.add.sprite(1430, 765, 'sound-button');
  caveman.soundKey = Math.floor(Math.random() * this.gameConfig.assets.sounds.length);
  caveman.setInteractive();
  this.cursorManager.setDefaultDraggableEvents(caveman);
  caveman.on('pointerup', this.playSound.bind(this, caveman), this);
  this.scaleAnimation(caveman);
  this.caveman = caveman;
};

SM.scaleAnimation = function (sprite, delay) {
  let randomDelay = delay;
  if (!delay) {
    randomDelay = 300;
  }
  sprite.scaleAnim = this.tweens.add({
    targets: sprite,
    scaleX: 1.1,
    scaleY: 1.1,
    duration: 400,
    ease: 'Sine.easeInOut',
    delay: randomDelay,
    yoyo: true,
    onComplete: this.scaleAnimation.bind(this, sprite, 6000 + Math.floor(Math.random() * 3000)),
  });
};

SM.playSound = function (caveman) {
  const musicArray = this.sound.getAll();
  for (let i = 0; i < musicArray.length; i++) {
    musicArray[i].setVolume(0.1);
  }
  const music = this.sound.add(`sound-${caveman.soundKey}`);
  music.play();
  music.once(
    'complete',
    function (music) {
      const musicArray = this.sound.getAll();
      for (let i = 0; i < musicArray.length; i++) {
        musicArray[i].setVolume(1);
      }
      music.destroy();
    },
    this,
  );
};

SM.createTemplateUI = function () {
  const titleFont = {
    font: `${this.gameConfig.titleSize} ${this.gameConfig.font}`,
  };
  const title = this.add
    .text(this.game.config.width / 2, 100, this.gameConfig.titleTxt, titleFont)
    .setOrigin(0.5)
    .setDepth(1);

  const instructions = this.make
    .text({
      x: 400,
      y: 650,
      text: this.gameConfig.instructionsTxt,
      origin: { x: 0, y: 0 },
      style: {
        fontFamily: `${this.gameConfig.font}`,
        fontSize: `${this.gameConfig.instructionsSize}`,
        wordWrap: { width: `${this.gameConfig.instructionsMaxWidth}` },
        lineSpacing: 12,
      },
    })
    .setDepth(1);
  this.otherSprites.push(title);
  this.otherSprites.push(instructions);
};

SM.backToStart = function (choice) {
  choice.shakeAnim = this.tweens.add({
    targets: choice,
    angle: 0,
    duration: 100,
    ease: 'Sine.easeInOut',
    yoyo: false,
    onComplete: this.startShakeAnimation.bind(this, choice),
  });
};

SM.startShakeAnimation = function (choice) {
  const repeats = 5;
  choice.shakeAnim = this.tweens.add({
    targets: choice,
    angle: 0,
    duration: 1,
    ease: 'Linear',
    yoyo: false,
    delay: 6000,
    onActive: this.moveRight.bind(this, choice, repeats),
  });
};

SM.moveRight = function (choice, repeats) {
  repeats--;
  if (repeats < 0) {
    this.backToStart(choice);
  } else {
    choice.shakeAnim = this.tweens.add({
      targets: choice,
      angle: 2,
      duration: 100,
      ease: 'Sine.easeInOut',
      yoyo: false,
      onComplete: this.moveLeft.bind(this, choice, repeats),
    });
  }
};

SM.moveLeft = function (choice, repeats) {
  choice.shakeAnim = this.tweens.add({
    targets: choice,
    angle: -2,
    duration: 100,
    ease: 'Sine.easeInOut',
    yoyo: false,
    onComplete: this.moveRight.bind(this, choice, repeats),
  });
};

export default EDC.Games.SoundsMultichoice.Scenes.Main;
